import { ActionTypes } from '../constants/ActionTypes';
import { AnyAction } from 'redux';
import { ISearchData } from '../models/ISearchData';
import { IBasicSearchData } from '../models/IBasicSearchData';
import { IAdvancedSearchData } from '../models/IAdvancedSearchData';
import { SCHEDULER_DAY_SPAN } from '../constants/DateConsts';
import { ISearchSelectedItem } from '../models/ISearchSelectedItem';


export function SearchReducer(state: ISearchData = {}, action: AnyAction): ISearchData {
    switch (action.type) {
        case ActionTypes.SET_BASIC_SEARCH_DATA:
            return SetBasicSearchData(state, action);
        case ActionTypes.SET_ADVANCED_SEARCH_DATA:
            return SetAdvancedSearchData(state, action);
        case ActionTypes.SET_FULL_CLIENT_STATE:
            return SetFullSearchData(state, action);
        case ActionTypes.SET_NEW_PAGE:
            return SetNewPage(state, action);
        case ActionTypes.RESET_SEARCH_DAY_SPAN:
            return ResetSearchDaySpan(state, action);
        case ActionTypes.SET_BASIC_SEARCH_DATA_AND_RESET_DAY_SPAN:
            return SetBasicSearchDataAndResetDaySpan(state, action);
        case ActionTypes.SET_SEARCH_SELECTED_ITEM:
            return SetSearchSelectedItem(state, action);
        case ActionTypes.SET_BASIC_SEARCH_DATA_AND_RESET_ADVANCED_CRITERIA:
            return SetBasicSearchDataAndResetAdvancedCriteria(state, action);
    }
    return state;
}

function SetBasicSearchData(state: ISearchData, action: AnyAction): ISearchData {
    let actionPayload: IBasicSearchData = action.payload;
    return {
        ...state,
        CriteriaInputValue: actionPayload.CriteriaInputValue,
        PlaceInputValue: actionPayload.PlaceInputValue,
        CriteriaInputSelectedItem: actionPayload.CriteriaInputSelectedItem
    };
}

function SetAdvancedSearchData(state: ISearchData, action: AnyAction): ISearchData {
    let actionPayload: IAdvancedSearchData = action.payload;
    return {
        ...state,
        SelectedDiseases: actionPayload.SelectedDiseases,
        SelectedTherapies: actionPayload.SelectedTherapies,
        SelectedDateFrom: actionPayload.SelectedDateFrom,
        SelectedDateTo: actionPayload.SelectedDateTo,
        SortOrder: actionPayload.SortOrder,
        FilterType: actionPayload.FilterType,
        CurrentPage: actionPayload.CurrentPage
    }
}

function SetFullSearchData(state: ISearchData, action: AnyAction): ISearchData {
    let actionPayload: ISearchData = action.payload.SearchData;
    return {
        ...actionPayload
    }
}

function SetNewPage(state: ISearchData, action: AnyAction): ISearchData {
    let actionPayload: number = action.payload;
    return {
        ...state,
        CurrentPage: actionPayload
    }
}

function ResetSearchDaySpan(state: ISearchData, action: AnyAction): ISearchData {
    let tmpDate = new Date();
    let daySpanFrom = new Date(tmpDate.getFullYear(), tmpDate.getMonth(), tmpDate.getDate() + 1);
    let daySpanTo = new Date(tmpDate.getFullYear(), tmpDate.getMonth(), tmpDate.getDate() + SCHEDULER_DAY_SPAN);
    return {
        ...state,
        SelectedDateFrom: daySpanFrom,
        SelectedDateTo: daySpanTo
    }
}

function SetBasicSearchDataAndResetDaySpan(state: ISearchData, action: AnyAction): ISearchData {
    let actionPayload: IBasicSearchData = action.payload;
    let tmpDate = new Date();
    let daySpanFrom = new Date(tmpDate.getFullYear(), tmpDate.getMonth(), tmpDate.getDate() + 1);
    let daySpanTo = new Date(tmpDate.getFullYear(), tmpDate.getMonth(), tmpDate.getDate() + SCHEDULER_DAY_SPAN);
    return {
        ...state,
        CriteriaInputValue: actionPayload.CriteriaInputValue,
        PlaceInputValue: actionPayload.PlaceInputValue,
        CriteriaInputSelectedItem: actionPayload.CriteriaInputSelectedItem,
        SelectedDateFrom: daySpanFrom,
        SelectedDateTo: daySpanTo,
        CurrentPage: 1,
    };
}

function SetBasicSearchDataAndResetAdvancedCriteria(state: ISearchData, action: AnyAction): ISearchData {
    let actionPayload: IBasicSearchData = action.payload;
    let tmpDate = new Date();
    let daySpanFrom = new Date(tmpDate.getFullYear(), tmpDate.getMonth(), tmpDate.getDate() + 1);
    let daySpanTo = new Date(tmpDate.getFullYear(), tmpDate.getMonth(), tmpDate.getDate() + SCHEDULER_DAY_SPAN);
    console.log(state)
    return {
        ...state,
        CriteriaInputValue: actionPayload.CriteriaInputValue,
        PlaceInputValue: actionPayload.PlaceInputValue,
        CriteriaInputSelectedItem: actionPayload.CriteriaInputSelectedItem,
        SelectedDateFrom: daySpanFrom,
        SelectedDateTo: daySpanTo,
        SelectedDiseases: undefined,
        SelectedTherapies: undefined,
        SortOrder: state.SortOrder,
        FilterType: state.FilterType,
        CurrentPage: 1
    };
}

function SetSearchSelectedItem(state: ISearchData, action: AnyAction): ISearchData {
    let actionPayload: ISearchSelectedItem = action.payload;
    return {
        ...state,
        CriteriaInputValue: actionPayload.Name,
        CriteriaInputSelectedItem: actionPayload
    };
}


// WEBPACK FOOTER //
// ./src/reducers/SearchReducer.tsx